import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

// On 401 try one silent token refresh, then retry; otherwise bounce to the login page.
client.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config || {};
    if (err?.response?.status === 401 && !cfg._retried) {
      cfg._retried = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return client(cfg);
      } catch (e) { /* fall through */ }
      if (!window.location.pathname.startsWith("/login")) window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export const getStats = () => client.get("/stats").then((r) => r.data);
export const getJobs = () => client.get("/jobs").then((r) => r.data);
export const getJob = (id) => client.get(`/jobs/${id}`).then((r) => r.data);
export const getSettings = () => client.get("/settings").then((r) => r.data);
export const saveSettings = (data) => client.put("/settings", data).then((r) => r.data);
export const uploadFile = (formData) =>
  client.post("/jobs/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const registerJob = (id) => client.post(`/jobs/${id}/register`).then((r) => r.data);
export const registerBatch = (ids) => client.post("/jobs/register-batch", { ids }).then((r) => r.data);
export const verifyLookup = (ids) => client.post("/jobs/verify-lookup", { ids: ids || null }).then((r) => r.data);
export const setInstallDate = (ids, install_date) => client.patch("/jobs/install-date", { ids: ids && ids.length ? ids : null, install_date }).then((r) => r.data);
export const stopBatch = (ids) => client.post("/jobs/stop", { ids: ids || null }).then((r) => r.data);
export const deleteJob = (id) => client.delete(`/jobs/${id}`).then((r) => r.data);
export const clearJobs = () => client.delete("/jobs?confirm=true").then((r) => r.data);
export const getFriendlyNames = () => client.get("/friendly-names").then((r) => r.data);
export const getAssistantSuggestions = () => client.get("/assistant/suggestions").then((r) => r.data);
export const askAssistant = ({ session_id, message }) =>
  client.post("/assistant/chat", { session_id, message }).then((r) => r.data);

export const certUrl = (id, part) => `${API}/jobs/${id}/certificate${part ? `?part=${part}` : ""}`;
export const certParts = (j) => Object.keys(j.certificates || (j.certificate ? { trane: j.certificate } : {}));
export const PART_LABEL = { trane: "Trane", daikin: "Daikin", rheem: "Rheem" };
export const screenshotUrl = (id, name) => `${API}/jobs/${id}/screenshot/${name}`;
export const templateUrl = `${API}/template`;

export const downloadZip = async (ids) => {
  const res = await client.post("/certificates/zip", { ids }, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = "warranty_registrations.zip";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
